import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient, type Client } from "graphql-ws";

/**
 * Create a configured GraphQL WebSocket link using the standard
 * graphql-ws protocol (graphql-transport-ws subprotocol).
 *
 * This replaces the legacy Absinthe Phoenix Channel transport with the
 * industry-standard GraphQL over WebSocket Protocol, compatible with
 * any graphql-ws–compliant server (including absinthe_graphql_ws).
 *
 * Authentication is passed via `connectionParams` in the `connection_init`
 * message, which the server's `handle_init/2` callback receives.
 */
export function createGraphqlWsLink(
  wsUrl: string,
  getToken: () => string | null,
): {
  link: GraphQLWsLink;
  wsClient: Client;
} {
  const wsClient = createClient({
    url: wsUrl,
    connectionParams: () => {
      const token = getToken();
      return token ? { Authorization: `Bearer ${token}` } : {};
    },
    // Automatically reconnect on non-fatal close events
    shouldRetry: () => true,
    // Lazy connection — only connect when a subscription is created
    lazy: true,
  });

  const link = new GraphQLWsLink(wsClient);

  return { link, wsClient };
}
